// Broadcast Theme – Seaspice custom JS

(function() {
  // On mobile, tapping a color swatch should act like hover (change image) instead of navigation
  document.addEventListener(
    'click',
    function(event) {
      // Only care about swatch links
      const swatchLink = event.target.closest('a.swatch__link');
      if (!swatchLink) return;

      // Only override on mobile / tablet
      if (window.innerWidth > 990) return;

      // Stop the normal behavior (opening the product/variant)
      event.preventDefault();
      event.stopPropagation();

      // Create synthetic hover events so Broadcast's own JS runs
      const mouseEnter = new Event('mouseenter', { bubbles: true, cancelable: true });
      const mouseOver  = new Event('mouseover',  { bubbles: true, cancelable: true });
      const pointerEnter = new Event('pointerenter', { bubbles: true, cancelable: true });

      swatchLink.dispatchEvent(mouseEnter);
      swatchLink.dispatchEvent(mouseOver);
      swatchLink.dispatchEvent(pointerEnter);
    },
    true // capture phase: run before Broadcast's handlers
  );
})();
